import { render, staticRenderFns } from "./tank.vue?vue&type=template&id=18c3d4e3&scoped=true&"
import script from "./tank.vue?vue&type=script&lang=js&"
export * from "./tank.vue?vue&type=script&lang=js&"
import style0 from "./tank.vue?vue&type=style&index=0&id=18c3d4e3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18c3d4e3",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
